import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Icon, Steps } from 'antd-mobile';
import { ClockCircleFill } from 'antd-mobile-icons';
import {post} from '../../utils/request';
import api from './api';

import './index.less';
import { getUrlParam } from '../../utils/util';

const { Step } = Steps

class WithdrawalResult extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            data: []
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.init()
    }

    init(){
        this.getData();
    }

    getData(){
        console.log(getUrlParam('gmtCreate'))
    }

    render() {
        const {data, urlOps} = this.state;
        
        return (
            <div className='result_bg' style={{ background: '#F3F4F5', height: document.documentElement.clientHeight }}>     
                <div style={{ background: '#fff' }}>
                <div style={{ height: '0.3rem' }}></div> 
                 <div className='resultIcon' style={{ marginBottom: '0.16rem' }}>{getUrlParam('cashOutType')=='0'?<Icon type='cross-circle-o' style={{ height: '0.44rem', width: '0.44rem', color: '#FE3824'}} />:<ClockCircleFill style={{ height: '0.44rem', width: '0.44rem', color: '#009F90'}} />}</div>
                 <p className='status' style={{ width: '1.1rem',paddingBottom: '0.6rem' }}>{getUrlParam('cashOutType')=='0'?'申请提交失败':'申请已提交'}</p>
                 {getUrlParam('cashOutType')=='0'?'':<Steps
                    direction='vertical'
                    current={1}
                    style={{ marginLeft: '0.22rem' }}
                    className='step'
                    >
                    <Step
                        title={<div><span>提现申请已提交{getUrlParam('cashOutType')=='2'?'':'，等待打款处理'}</span><div style={{ fontSize:'0.12rem', color: '#999999', fontFamily: 'PingFangSC-Regular, PingFang SC',fontWeight: 400 }}>{getUrlParam('gmtCreate')}</div></div>}
                        icon={<div className='circle'></div>}
                    />
                    <Step
                        title={(getUrlParam('cashOutType')=='2'?'预计在当天内到账':'预计在15天内到账')}
                        icon={<div className='circle disabled'></div>}
                    />
                </Steps>}
                </div> 
                <Button type='primary' style={{ margin: '0.4rem 0.16rem' }} onClick={()=>window.history.back()}>返回</Button>
            </div>
        );
    }
}
export default WithdrawalResult;


// WEBPACK FOOTER //
// ./src/withdrawal/index/result.js